import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ToastInfoEnum } from '../../../toast/toast.info.enum';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-hover-tooltip',
    templateUrl: './hover-tooltip.component.html',
    styleUrls: ['./hover-tooltip.component.scss'],
    standalone: false
})
export class HoverTooltipComponent {
  infoMessageTypes = ToastInfoEnum;

  @Input() infoType: string;
  @Input() isFlowingOut = false;
}
